import { useSelector } from 'react-redux'
import { css } from '@emotion/react'
import config from 'config'
import { selectOnboardingLayoutVariant } from '../selectors'

const style = () => theme => css`
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: ${theme.spacing['16']} !important;
  // Helply color that isnt currently in design system
  color: #120036;
  font-weight: ${theme.fontWeight.normal};
  strong {
    font-weight: ${theme.fontWeight.semiBold};
  }
`

const PageHeader = ({ children }) => {
  const layoutVariant = useSelector(selectOnboardingLayoutVariant)
  return (
    <p
      css={[style]}
      className={layoutVariant === 3 && 'Onboarding_PageHeader-v3'}
    >
      {children || (
        <>
          Groove is the simple, easy way for Shopify stores to deliver “holy
          $#!&, that was fast” customer service.<br />
          <strong>{config.trialDays} day free trial.</strong>
        </>
      )}
    </p>
  )
}

export default PageHeader
